{
  "CallsheetPublic": {
    "loadingTitle": "Ładowanie harmonogramu",
    "notPublishedTitle": "Harmonogram nie został opublikowany",
    "notPublishedSubtitle": "Harmonogram jest w stanie roboczym. Powiadom autora, że musi opublikować harmonogram.",
    "poweredByAtellio": "Powered by Atellio",
    "metaDescription": "Harmonogram przygotowany przez {{teamName}} z {{companyName}}",
    "builtWith": "Zbudowane przy użyciu"
  },
  "PublicCallsheetView": {
    "callsheetFor": "Harmonogram dla",
    "confirmReceived": "Potwierdź odbiór",
    "confirmed": "Potwierdzono"
  },
  "CallsheetPdfButton": {
    "downloadAsPDF": "Pobierz jako PDF"
  },
  "CallsheetContacts": {
    "name": "Imię",
    "role": "Rola",
    "removeContact": "Usuń kontakt",
    "mainContacts": "Główny kontakt",
    "addContact": "Dodaj kontakt"
  },
  "CallsheetCallTime": {
    "toLabel": "Do",
    "fromLabel": "Od",
    "removeDate": "Usuń datę",
    "addDateRange": "Dodaj zakres dat",
    "yourCallTime": "Twój czas wezwania",
    "generalCrewCallTime": "Ogólny czas wezwania ekipy"
  },
  "CallsheetOutline": {
    "title": "Konspekt",
    "placeholder": "Napisz konspekt dotyczący dnia"
  },
  "CallsheetSectionSchedule": {
    "schedule": "Harmonogram",
    "removeTime": "Usuń czas",
    "addTime": "Dodaj czas",
    "title": "Tytuł",
    "description": "Opis",
    "removeLocation": "Usuń lokalizację",
    "addSchedule": "Dodaj harmonogram"
  },
  "CallsheetSectionLocation": {
    "header": "Lokalizacja",
    "removeLocation": "Usuń lokalizację",
    "addLocation": "Dodaj lokalizację",
    "weather": "Pogoda",
    "weatherUnavailable": "Pogoda pojawi się po publikacji",
    "high": "Max",
    "low": "Min"
  },
  "CallsheetTeamMembers": {
    "addResource": "Dodaj zasób",
    "newGroup": "Nowa grupa"
  },
  "CallsheetTeamItem": {
    "actions": "Akcje członka ekipy",
    "role": "Rola",
    "note": "Notatka",
    "purchaseOrder": "Nr PO",
    "email": "Email",
    "phone": "Telefon",
    "callTime": "Czas wezwania",
    "addEmail": "Dodaj email",
    "addPhoneNumber": "Dodaj numer telefonu",
    "removePersonalCallTime": "Usuń osobisty czas wezwania",
    "showPersonalCallTime": "Pokaż osobisty czas wezwania",
    "removeContactDetails": "Usuń dane kontaktowe",
    "showContactDetails": "Pokaż dane kontaktowe",
    "addPersonalNote": "Dodaj osobistą notatkę",
    "editPersonalNote": "Edytuj osobistą notatkę",
    "removeTeamMember": "Usuń członka ekipy"
  },
  "CallsheetTeamGroup": {
    "addSlot": "Dodaj slot",
    "addGroup": "Dodaj grupę"
  },
  "CallsheetTeamGroupHeader": {
    "groupName": "Nazwa grupy",
    "removeGroup": "Usuń grupę",
    "areYouSure": "Czy na pewno?",
    "removeGroupWarning": "Spowoduje to usunięcie wszystkich slotów powiązanych z tą grupą",
    "delete": "Usuń",
    "groupNotEmpty": "Grupa nie jest pusta",
    "groupNotEmptyDesc": "Nie możesz usunąć grupy, jeśli zawiera role i wydatki. Przenieś je do innej grupy lub usuń, aby kontynuować."
  },
  "CallsheetTeamSectionHeader": {
    "areYouSure": "Czy na pewno?",
    "removeSectionWarning": "Spowoduje to usunięcie wszystkich slotów powiązanych z tą produkcją",
    "delete": "Usuń"
  },
  "CallsheetDocument": {
    "displayError": "Nie można wyświetlić harmonogramu",
    "billing": "Rozliczenia",
    "social": "Media społecznościowe",
    "hardDrive": "Dysk twardy"
  },
  "CallsheetSectionNotes": {
    "title": "Dodatkowe notatki",
    "placeholder": "Napisz dodatkowe notatki…"
  },
  "CallsheetLocationMap": {
    "directions": "Wskazówki otwierane w nowym oknie",
    "map": "Mapa",
    "mapOf": "Mapa: {{destination}}"
  },
  "CallsheetPdf": {
    "address": "Adres",
    "purchaseOrderFor": "Numer zamówienia dla {{displayName}}: {{purchaseOrder}}",
    "billing": "Rozliczenia",
    "social": "Media społecznościowe",
    "hardDrive": "Dysk twardy",
    "outline": "Konspekt",
    "descriptionHere": "Opis tutaj",
    "personalNote": "Notatka osobista dla {{displayName}}",
    "poNumber": "Nr PO:",
    "callTime": "Czas wezwania",
    "for": "dla",
    "from": "Od",
    "to": "Do",
    "mainContacts": "Główny kontakt",
    "mainContactsPlural": "Główne kontakty",
    "location": "Lokalizacja",
    "schedule": "Harmonogram",
    "additionalNotes": "Dodatkowe notatki",
    "attachments": "Załączniki",
    "fileURL": "URL pliku",
    "weather": "Pogoda",
    "high": "Max",
    "low": "Min",
    "note": "Notatka"
  }
}
